<div class="space-y-4 pb-4 animate-fade-in">
    <!-- Header Shared Component -->
    <app-section-header title="Panel de Control" description="Analíticas en tiempo real"
        icon="solar:chart-square-bold-duotone">
        <ng-template #metricsTemplate>
            <div class="flex items-center gap-2">
                <!-- Date Filters (Ultra Compact) -->
                <div
                    class="flex items-center bg-white border border-foreground/[0.05] rounded-lg px-2 py-0.5 shadow-sm gap-2">
                    <div class="flex flex-col">
                        <span class="text-[6.5px] font-black uppercase text-foreground/60 leading-none">Desde</span>
                        <input type="date" [ngModel]="startDate()" (ngModelChange)="startDate.set($event)"
                            class="text-[10px] font-bold text-foreground bg-transparent border-none outline-none p-0 h-3">
                    </div>
                    <div class="w-[1px] h-4 bg-foreground/[0.05]"></div>
                    <div class="flex flex-col">
                        <span class="text-[6.5px] font-black uppercase text-foreground/60 leading-none">Hasta</span>
                        <input type="date" [ngModel]="endDate()" (ngModelChange)="endDate.set($event)"
                            class="text-[10px] font-bold text-foreground bg-transparent border-none outline-none p-0 h-3">
                    </div>
                </div>

                <app-button variant="glass" size="xs" [square]="true" (btnClick)="reload()" [spinIconOnHover]="true"
                    iconLeft="solar:refresh-bold-duotone">
                </app-button>
            </div>
        </ng-template>
    </app-section-header>

    <!-- Content -->
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 relative min-h-[60px]">
        <!-- Loading Overlay -->
        <div *ngIf="statsResource.isLoading()"
            class="absolute inset-0 z-20 bg-white/40 backdrop-blur-[1px] rounded-xl flex items-center justify-center">
            <iconify-icon icon="solar:refresh-circle-bold-duotone" class="text-primary animate-spin"
                width="20"></iconify-icon>
        </div>

        @for (stat of statsResource.value()?.stats; track stat.label) {
        <app-card [animate]="true" padding="none"
            class="border-foreground/[0.03] shadow-none hover:border-primary/20 transition-all overflow-visible">
            <div class="py-2.5 px-3.5 flex items-center gap-3.5 relative pointer-events-none">
                <div [class]="stat.bg"
                    class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 shadow-sm border border-foreground/[0.02]">
                    <iconify-icon [icon]="stat.icon" [class]="stat.color" width="20"></iconify-icon>
                </div>
                <div class="flex flex-col min-w-0">
                    <p class="text-[9px] font-bold text-slate-500/60 uppercase tracking-widest leading-none mb-1">{{
                        stat.label }}</p>
                    <div class="flex items-baseline gap-1.5">
                        <h3 class="text-lg font-black text-slate-800 tracking-tighter leading-none">{{ stat.value }}
                        </h3>
                        <span class="text-[8px] font-black px-1 py-0.5 rounded bg-foreground/[0.01]"
                            [ngClass]="stat.trend.startsWith('-') ? 'text-red-500' : 'text-emerald-500'">{{ stat.trend
                            }}</span>
                    </div>
                </div>
            </div>
        </app-card>
        }

        @if (inventoryResource.value(); as inv) {
        <app-card [animate]="true" padding="none"
            class="bg-white dark:bg-slate-900 border-foreground/[0.03] shadow-none hover:border-primary/20 transition-all cursor-pointer overflow-visible"
            routerLink="/app/inventory/catalog">
            <div class="py-2.5 px-3.5 flex items-center gap-3.5 relative">
                <div
                    class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 shadow-sm border border-foreground/[0.02] bg-primary-500/10 text-primary">
                    <iconify-icon icon="solar:box-bold-duotone" width="20"></iconify-icon>
                </div>
                <div class="flex flex-col min-w-0">
                    <p class="text-[9px] font-bold text-slate-500/60 uppercase tracking-widest leading-none mb-1">
                        Productos</p>
                    <div class="flex items-baseline gap-1.5">
                        <h3 class="text-lg font-black text-slate-800 dark:text-white tracking-tighter leading-none">{{
                            inv.totalProducts }}</h3>
                        <span
                            class="text-[8px] font-black px-1 py-0.5 rounded bg-primary-500/10 text-primary">Total</span>
                    </div>
                </div>
            </div>
        </app-card>

        <app-card [animate]="true" padding="none"
            class="bg-white dark:bg-slate-900 border-foreground/[0.03] shadow-none hover:border-orange-500/20 transition-all cursor-pointer overflow-visible"
            routerLink="/app/inventory/catalog">
            <div class="py-2.5 px-3.5 flex items-center gap-3.5 relative">
                <div
                    class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 shadow-sm border border-foreground/[0.02] bg-orange-500/10 text-orange-600">
                    <iconify-icon icon="solar:box-minimalistic-bold-duotone" width="20"></iconify-icon>
                </div>
                <div class="flex flex-col min-w-0">
                    <p class="text-[9px] font-bold text-slate-500/60 uppercase tracking-widest leading-none mb-1">Bajo
                        Stock</p>
                    <div class="flex items-baseline gap-1.5">
                        <h3 class="text-lg font-black text-slate-800 dark:text-white tracking-tighter leading-none">{{
                            inv.lowStockCount }}</h3>
                        <span
                            class="text-[8px] font-black px-1 py-0.5 rounded bg-orange-500/10 text-orange-600">Alertas</span>
                    </div>
                </div>
            </div>
        </app-card>

        <app-card [animate]="true" padding="none"
            class="bg-white dark:bg-slate-900 border-foreground/[0.03] shadow-none hover:border-indigo-500/20 transition-all cursor-pointer overflow-visible"
            routerLink="/app/inventory/catalog">
            <div class="py-2.5 px-3.5 flex items-center gap-3.5 relative">
                <div
                    class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 shadow-sm border border-foreground/[0.02] bg-indigo-500/10 text-indigo-600">
                    <iconify-icon icon="solar:tag-bold-duotone" width="20"></iconify-icon>
                </div>
                <div class="flex flex-col min-w-0">
                    <p class="text-[9px] font-bold text-slate-500/60 uppercase tracking-widest leading-none mb-1">
                        Categorías</p>
                    <div class="flex items-baseline gap-1.5">
                        <h3 class="text-lg font-black text-slate-800 dark:text-white tracking-tighter leading-none">{{
                            inv.categoryCount }}</h3>
                        <span
                            class="text-[8px] font-black px-1 py-0.5 rounded bg-indigo-500/10 text-indigo-600">Gestionar</span>
                    </div>
                </div>
            </div>
        </app-card>
        }
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <app-card class="bg-white dark:bg-slate-900 border-foreground/[0.04] shadow-none" padding="md">
            <div class="flex items-center justify-between mb-5 pb-2 border-b border-foreground/[0.03]">
                <h3
                    class="text-[11px] font-black text-slate-800 dark:text-white/90 uppercase tracking-tight flex items-center gap-2">
                    <iconify-icon icon="solar:chart-square-bold-duotone" class="text-primary" width="16"></iconify-icon>
                    Actividad de Citas
                </h3>
            </div>

            <div class="h-[180px] flex items-end justify-between gap-3 px-1 relative">
                @for (item of statsResource.value()?.chartData; track item.label) {
                <div class="group flex-1 flex flex-col items-center gap-3 h-full justify-end">
                    <div class="w-full bg-primary/10 rounded-md hover:bg-primary/30 transition-all cursor-pointer relative"
                        [style.height.%]="(item.value / (maxChartValue || 1)) * 100">
                        <div
                            class="absolute -top-10 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-[10px] font-black px-2.5 py-1 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-all z-20 pointer-events-none whitespace-nowrap">
                            {{ item.value }} Citas
                        </div>
                    </div>
                    <span class="text-[9px] font-black text-foreground/50 uppercase tracking-tighter">{{ item.label
                        }}</span>
                </div>
                }

                @if (statsResource.value()?.chartData?.length === 0) {
                <div class="absolute inset-0 flex flex-col items-center justify-center opacity-10">
                    <iconify-icon icon="solar:chart-line-linear" width="48"></iconify-icon>
                </div>
                }
            </div>
        </app-card>

        <app-card class="bg-white dark:bg-slate-900 border-foreground/[0.04] shadow-none" padding="md">
            <div class="flex items-center justify-between mb-4 border-b border-foreground/[0.03] pb-2">
                <h3
                    class="text-[11px] font-black text-slate-800 dark:text-white/90 uppercase tracking-tight flex items-center gap-2">
                    <iconify-icon icon="solar:calendar-minimalistic-bold-duotone" class="text-primary"
                        width="16"></iconify-icon>
                    Agenda del Día
                </h3>
                <app-button variant="outline" size="xs" color="text-primary" routerLink="/app/appointments"
                    class="text-[9px] font-black uppercase tracking-wider">Ver Agenda Completa</app-button>
            </div>

            <div class="h-[180px] overflow-y-auto custom-scrollbar">
                <div class="space-y-2.5">
                    @for (item of statsResource.value()?.upcomingAppointments; track item.patientName + item.time) {
                    <div
                        class="flex items-center gap-3.5 p-3 rounded-lg bg-foreground/[0.02] border border-transparent hover:border-primary/20 hover:bg-white hover:shadow-sm transition-all group cursor-pointer">
                        <div
                            class="w-10 h-10 rounded-lg bg-primary/5 flex-shrink-0 flex items-center justify-center group-hover:bg-primary/10 transition-colors">
                            <iconify-icon icon="solar:user-circle-bold-duotone" class="text-primary"
                                width="22"></iconify-icon>
                        </div>
                        <div class="min-w-0 flex-1">
                            <h4 class="text-xs font-black text-slate-800 dark:text-white/90 tracking-tight truncate">{{
                                item.patientName }}</h4>
                            <div class="flex items-center gap-2 mt-1">
                                <span
                                    class="bg-primary/10 text-primary text-[9px] font-black px-1.5 py-0.5 rounded leading-none">{{
                                    item.time }}</span>
                                <span class="text-[10px] text-foreground/50 font-bold truncate">{{ item.procedure
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    }

                    @if (statsResource.value()?.upcomingAppointments?.length === 0) {
                    <div class="col-span-full h-full flex flex-col items-center justify-center opacity-20">
                        <iconify-icon icon="solar:calendar-add-linear" width="32"></iconify-icon>
                        <p class="text-[9px] font-black uppercase tracking-widest mt-2">Sin citas programadas</p>
                    </div>
                    }
                </div>
            </div>
        </app-card>
    </div>

    @if (inventoryResource.value(); as inv) {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 animate-slide-up">
        <app-card padding="md" class="block bg-white dark:bg-slate-900 border-foreground/[0.04] shadow-none">
            <div class="flex flex-col gap-0.5 mb-5 pb-2 border-b border-foreground/[0.03]">
                <h3
                    class="text-[11px] font-black text-slate-800 dark:text-white uppercase tracking-tight flex items-center gap-2">
                    <iconify-icon icon="solar:bell-bing-bold-duotone" class="text-orange-500" width="16"></iconify-icon>
                    Alertas de Stock Bajo
                </h3>
            </div>

            <div class="space-y-4 max-h-[350px] overflow-y-auto pr-1 custom-scrollbar">
                @if (inv.lowStockItems.length === 0) {
                <div class="py-10 flex flex-col items-center justify-center opacity-10">
                    <iconify-icon icon="solar:check-circle-linear" width="40"></iconify-icon>
                    <p class="text-[9px] font-black uppercase tracking-widest mt-2">Todo en orden</p>
                </div>
                }

                @for (item of inv.lowStockItems; track item._id) {
                <div
                    class="flex items-center justify-between pb-3 border-b border-foreground/[0.02] last:border-0 group">
                    <div class="flex flex-col min-w-0">
                        <span
                            class="text-[11px] font-black text-slate-800 dark:text-slate-200 truncate group-hover:text-primary transition-colors leading-tight">{{
                            item.name }}</span>
                        <div class="flex items-center gap-2 mt-0.5">
                            <span class="text-[10px] font-bold text-slate-400 capitalize">Mínimo: {{ item.minimumStock
                                }}</span>
                            <div class="w-1 h-1 rounded-full bg-slate-300"></div>
                            <span class="text-[10px] font-black text-rose-500 uppercase tracking-tighter">Actual: {{
                                item.currentStock }}</span>
                        </div>
                    </div>
                    <app-button variant="glass" size="xs" color="text-orange-600" [square]="true"
                        (btnClick)="reorder(item)" title="Reponer Insumo">
                        <iconify-icon icon="solar:refresh-circle-bold-duotone" width="18"></iconify-icon>
                    </app-button>
                </div>
                }
            </div>
        </app-card>

        <app-card padding="md" class="block bg-white dark:bg-slate-900 border-foreground/[0.04] shadow-none">
            <div class="flex flex-col gap-0.5 mb-5 pb-2 border-b border-foreground/[0.03]">
                <h3
                    class="text-[11px] font-black text-slate-800 dark:text-white uppercase tracking-tight flex items-center gap-2">
                    <iconify-icon icon="solar:history-bold-duotone" class="text-indigo-500" width="16"></iconify-icon>
                    Vencimientos Próximos
                </h3>
            </div>

            <div class="space-y-4 overflow-y-auto pr-1 custom-scrollbar h-full">
                @if (inv.expiringSoonItems.length === 0) {
                <div class="py-10 flex flex-col items-center justify-center opacity-10">
                    <iconify-icon icon="solar:history-linear" width="40"></iconify-icon>
                    <p class="text-[10px] font-black uppercase tracking-widest mt-2">Sin vencimientos</p>
                </div>
                }

                @for (batch of inv.expiringSoonItems; track batch._id) {
                <div class="flex items-center justify-between pb-3 group">
                    <div class="flex flex-col min-w-0">
                        <span
                            class="text-[11px] font-black text-slate-800 dark:text-slate-200 truncate group-hover:text-indigo-500 transition-colors leading-tight">{{
                            batch.product.name }}</span>
                        <div class="flex items-center gap-2 mt-0.5">
                            <span class="text-[10px] font-bold text-slate-400 capitalize">Lote: {{ batch.lotNumber ||
                                'S/N' }}</span>
                            <div class="w-1 h-1 rounded-full bg-slate-200"></div>
                            <span class="text-[10px] font-bold text-indigo-500">Stock: {{ batch.currentQuantity
                                }}</span>
                        </div>
                    </div>
                    <div class="flex flex-col items-end shrink-0">
                        <span class="text-[11px] font-black text-rose-500 uppercase tracking-tighter">{{
                            batch.expiryDate | date:'dd/MM/yy' }}</span>
                        <span class="text-[9px] text-slate-400 font-bold uppercase tracking-tight">Caducción</span>
                    </div>
                </div>
                }
            </div>
        </app-card>

        <app-card padding="md"
            class="block bg-white dark:bg-slate-900 border-foreground/[0.04] shadow-none lg:col-span-2">
            <div class="flex flex-col gap-0.5 mb-5 pb-3 border-b border-foreground/[0.03]">
                <div class="flex items-center justify-between">
                    <h3
                        class="text-[11px] font-black text-slate-800 dark:text-white uppercase tracking-tight flex items-center gap-2">
                        <iconify-icon icon="solar:history-bold-duotone" class="text-primary" width="16"></iconify-icon>
                        Historial de Movimientos del Inventario
                    </h3>
                    <app-button variant="outline" size="xs" color="text-primary" routerLink="/app/inventory/catalog"
                        class="text-[9px] font-black uppercase">Ver Catálogo Completo</app-button>
                </div>
            </div>

            <div class="overflow-x-auto">
                <table class="w-full text-left border-separate border-spacing-y-2">
                    <thead>
                        <tr class="text-slate-400">
                            <th class="px-4 pb-1 text-[10px] font-black uppercase tracking-widest">Fecha & Hora</th>
                            <th class="px-4 pb-1 text-[10px] font-black uppercase tracking-widest">Detalle Insumo</th>
                            <th class="px-4 pb-1 text-[10px] font-black uppercase tracking-widest text-center">Tipo</th>
                            <th class="px-4 pb-1 text-[10px] font-black uppercase tracking-widest">Lote No.</th>
                            <th class="px-4 pb-1 text-[10px] font-black uppercase tracking-widest">Vence</th>
                            <th class="px-4 pb-1 text-[10px] font-black uppercase tracking-widest text-right">Cant.</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (tx of inv.recentTransactions; track tx._id) {
                        <tr class="group transition-all">
                            <td
                                class="bg-slate-50 dark:bg-slate-800/40 px-4 py-3 rounded-l-xl text-[10px] font-black text-slate-500">
                                {{ tx.createdAt | date:'dd/MM HH:mm' }}
                            </td>
                            <td class="bg-slate-50 dark:bg-slate-800/40 px-4 py-3">
                                <span
                                    class="text-xs font-black text-slate-800 dark:text-white block truncate max-w-[180px] leading-tight">{{
                                    tx.product.name }}</span>
                            </td>
                            <td class="bg-slate-50 dark:bg-slate-800/40 px-4 py-3 text-center">
                                <span
                                    class="inline-block text-[9px] font-black px-3 py-1 rounded-full uppercase tracking-tighter"
                                    [ngClass]="getTransactionTypeClass(tx.type)">
                                    {{ getTransactionTypeLabel(tx.type) }}
                                </span>
                            </td>
                            <td class="bg-slate-50 dark:bg-slate-800/40 px-4 py-3">
                                <span
                                    class="text-[10px] font-black text-slate-600 dark:text-slate-400 font-mono tracking-tighter">{{
                                    tx.lotNumber || 'S/N' }}</span>
                            </td>
                            <td
                                class="bg-slate-50 dark:bg-slate-800/40 px-4 py-3 text-[10px] font-black tracking-tighter">
                                <span [class.text-rose-500]="tx.expiryDate" [class.text-slate-300]="!tx.expiryDate">
                                    {{ tx.expiryDate ? (tx.expiryDate | date:'dd/MM/yy') : '-' }}
                                </span>
                            </td>
                            <td class="bg-slate-50 dark:bg-slate-800/40 px-4 py-3 text-right">
                                <div class="flex flex-col items-end leading-none">
                                    <span class="text-xs font-black tracking-tighter"
                                        [class.text-emerald-500]="tx.type === 'IN'"
                                        [class.text-rose-500]="tx.type === 'OUT' || tx.type === 'DEDUCTION'">
                                        {{ tx.type === 'OUT' || tx.type === 'DEDUCTION' ? '−' : '+' }}{{ tx.quantity }}
                                    </span>
                                    <span class="text-[8px] font-bold text-slate-400 uppercase mt-0.5">{{
                                        tx.product.unitOfMeasure }}</span>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>

                @if (inv.recentTransactions.length === 0) {
                <div class="py-12 text-center opacity-10">
                    <iconify-icon icon="solar:transfer-horizontal-linear" width="40"></iconify-icon>
                    <p class="text-[11px] font-black uppercase tracking-widest mt-2">Sin movimientos</p>
                </div>
                }
            </div>
        </app-card>
    </div>
    }

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <app-card class="bg-white dark:bg-slate-900 border-foreground/[0.04] shadow-none" padding="md">
            <div class="flex flex-col gap-0.5 mb-5 pb-2 border-b border-foreground/[0.03]">
                <h3
                    class="text-[11px] font-black text-slate-800 dark:text-white/90 uppercase tracking-tight flex items-center gap-2">
                    <iconify-icon icon="solar:pie-chart-2-bold-duotone" class="text-indigo-500"
                        width="16"></iconify-icon>
                    Ingresos por Categoría
                </h3>
            </div>

            <div class="space-y-4 h-[140px] overflow-y-auto pr-1 custom-scrollbar">
                @for (item of statsResource.value()?.revenueByCategory; track item.label) {
                <div class="space-y-2">
                    <div class="flex justify-between items-center text-[10px] font-bold uppercase tracking-tight">
                        <span class="text-slate-600 truncate mr-2">{{ item.label }}</span>
                        <span class="text-primary font-black">${{ item.value | number:'1.2-2' }}</span>
                    </div>
                    <div class="h-2.5 w-full bg-slate-100 dark:bg-slate-800/50 rounded-full overflow-hidden">
                        <div class="h-full bg-indigo-500 rounded-full transition-all duration-700"
                            [style.width.%]="(item.value / (totalRevenueByCategory || 1)) * 100"></div>
                    </div>
                </div>
                }

                @if (statsResource.value()?.revenueByCategory?.length === 0) {
                <div class="h-full flex flex-col items-center justify-center opacity-10">
                    <iconify-icon icon="solar:pie-chart-linear" width="40"></iconify-icon>
                    <p class="text-[9px] font-black uppercase tracking-widest mt-2">Sin datos</p>
                </div>
                }
            </div>
        </app-card>

        <app-card class="bg-white dark:bg-slate-900 border-foreground/[0.04] shadow-none" padding="md">
            <div class="flex flex-col gap-0.5 mb-4 pb-2 border-b border-foreground/[0.03]">
                <h3
                    class="text-[11px] font-black text-slate-800 dark:text-white/90 uppercase tracking-tight flex items-center gap-2">
                    <iconify-icon icon="solar:user-plus-bold-duotone" class="text-emerald-500"
                        width="14"></iconify-icon>
                    Nuevos Pacientes
                </h3>
            </div>

            <div class="h-[140px] flex items-end justify-between gap-2 px-1 relative">
                @for (item of statsResource.value()?.patientGrowth; track item.label) {
                <div class="flex-1 flex flex-col items-center gap-2 h-full justify-end group">
                    <div class="w-full bg-emerald-500/10 rounded border border-emerald-500/5 relative"
                        [style.height.%]="(item.value / (maxPatientGrowthValue || 1)) * 100">
                        <div
                            class="absolute -top-6 left-1/2 -translate-x-1/2 text-[9px] font-black text-emerald-600 opacity-0 group-hover:opacity-100 transition-opacity">
                            {{ item.value }}
                        </div>
                    </div>
                    <span class="text-[8px] font-black text-foreground/40 uppercase tracking-tighter">{{ item.label
                        }}</span>
                </div>
                }
            </div>
        </app-card>
    </div>

</div>
